module.exports = __webpack_public_path__ + "static/media/ic_elllipse_circle_selected.aa902f1d.svg";